import { Component, computed, inject, linkedSignal } from '@angular/core';
import { RouterLink } from '@angular/router';

import { UIIconComponent } from '@design-system';
import { AppClockComponent } from '../app-clock/app-clock.component';
import { HeaderEventConsumerService } from './events/header-event-consumer.service';
import { HeaderEventProducerService } from './events/header-event-producer.service';
import { HeaderItem } from './events/header-events.model';

@Component({
	selector: 'app-header',
	imports: [UIIconComponent, RouterLink, AppClockComponent],
	templateUrl: './header.component.html'
})
export class HeaderComponent {
	private readonly headerEventConsumer = inject(HeaderEventConsumerService);
	private readonly headerEventProducer = inject(HeaderEventProducerService);

	readonly visible = computed(() => this.headerEventConsumer.configuration().visible);
	readonly showLogo = computed(() => this.headerEventConsumer.configuration().showLogo);
	readonly showClock = computed(() => this.headerEventConsumer.configuration().showClock);
	readonly title = computed(() => this.headerEventConsumer.configuration().title);
	readonly symbol = computed(() => this.headerEventConsumer.configuration().symbol);
	readonly headerRightSectionItems = computed(() => this.headerEventConsumer.configuration().headerRightSectionItems);
	readonly headerLeftSectionItems = computed(() => this.headerEventConsumer.configuration().headerLeftSectionItems);

	private readonly reloadingIds = computed(() =>
		[...this.headerRightSectionItems(), ...this.headerLeftSectionItems()]
			.filter(item => item.reloading)
			.map(item => item.eventId)
	);

	readonly spinningIds = linkedSignal<string[], ReadonlySet<string>>({
		source: this.reloadingIds,
		computation: (ids, previous) => new Set([...(previous?.value ?? []), ...ids])
	});

	onItemClick(item: HeaderItem): void {
		this.headerEventProducer.publishItemClick(item);
	}

	onSpinRoundComplete(item: HeaderItem): void {
		if (item.reloading) return;
		this.spinningIds.update(ids => new Set([...ids].filter(id => id !== item.eventId)));
	}
}
